/**
 * The menu path to mark for `pathname`: the most specific item that is the page itself or a parent of
 * it (`/actions` for `/actions/X/show`, but `/territories/map` over `/territories`), if any.
 */
export const activeMenuPath = (pathname: string, menuPaths: string[]): string | undefined =>
  [...menuPaths]
    .sort((a, b) => b.length - a.length)
    .find(path => pathname === path || pathname.startsWith(`${path}/`));
